import type { LegalSection } from './legalMeta';
import { LEGAL_META } from './legalMeta';

export const childSafetyStandardsTitle = 'Child Safety Standards';

export const childSafetyStandardsSections: LegalSection[] = [
  {
    id: 'overview',
    title: 'Overview',
    paragraphs: [
      `${LEGAL_META.brandMark} (${LEGAL_META.brandName}) is operated by ${LEGAL_META.legalEntityName}. This page describes our published standards against child sexual abuse and exploitation (CSAE) and how we address child sexual abuse material (CSAM) on our platform.`,
      `These standards apply to the ${LEGAL_META.brandName} mobile app and related services. We maintain zero tolerance for CSAE and CSAM.`,
    ],
  },
  {
    id: 'standards-against-csae',
    title: 'Standards Against CSAE',
    paragraphs: [
      'CSAE includes content or behavior that sexually exploits, abuses, or endangers children. We prohibit all of the following on ' +
        LEGAL_META.brandName +
        ':',
    ],
    listItems: [
      'Child sexual abuse material (CSAM) in any form, including photos, videos, or computer-generated imagery depicting minors in sexually explicit conduct.',
      'Grooming a child for sexual exploitation or abuse.',
      'Sextortion or coercion involving minors.',
      'Trafficking of a child for sexual purposes.',
      'Any other conduct that sexually exploits, abuses, or endangers children.',
      'Content that sexualizes minors or presents minors in a sexually suggestive manner.',
    ],
  },
  {
    id: 'user-expectations',
    title: 'User Expectations',
    paragraphs: [
      `${LEGAL_META.brandName} is intended for users aged ${LEGAL_META.minimumAge} and older. Users must not upload, share, solicit, or facilitate CSAE or CSAM.`,
      'Our Community Guidelines and Terms of Service reinforce these rules. Violations may result in immediate content removal, account suspension, or permanent ban.',
    ],
  },
  {
    id: 'csam-response',
    title: 'Addressing CSAM',
    paragraphs: [
      'When we obtain actual knowledge of CSAM or CSAE on our platform, we take appropriate action in accordance with these standards and applicable law. Our response may include:',
    ],
    listItems: [
      'Removing reported or identified CSAM and related content without delay.',
      'Suspending or permanently banning accounts involved in CSAE or CSAM.',
      'Preserving relevant evidence as required by law.',
      'Reporting CSAM and related illegal activity to the National Center for Missing & Exploited Children (NCMEC) CyberTipline and other appropriate authorities where required by law.',
      'Cooperating with law enforcement and trusted industry partners when legally permitted.',
    ],
  },
  {
    id: 'in-app-reporting',
    title: 'In-App Reporting',
    paragraphs: [
      'Users can report concerns from within the ' + LEGAL_META.brandName + ' app:',
      'We review valid safety reports promptly and aim to act within 24 hours, including removing content and restricting accounts when appropriate.',
    ],
    listItems: [
      'Use the in-app Report option on posts or user profiles from the feed or profile menus. Confirming a report opens a pre-filled email to ' +
        LEGAL_META.supportEmail +
        ' so you can send details to our moderation team.',
      'Block users in the app to stop seeing their content.',
      'If your device cannot open email from the app, contact ' +
        LEGAL_META.supportEmail +
        ' directly with “Report” in the subject line and include links, usernames, or screenshots when possible.',
    ],
  },
  {
    id: 'legal-compliance',
    title: 'Legal Compliance',
    paragraphs: [
      'We comply with applicable child safety laws and regulations, including U.S. federal requirements relating to CSAM reporting where applicable.',
      'We design our policies and enforcement procedures to align with widely recognized industry child safety practices.',
    ],
  },
  {
    id: 'contact',
    title: 'Child Safety Point of Contact',
    paragraphs: [
      `Designated contact for ${LEGAL_META.brandName} child safety and CSAM prevention practices:`,
      `Name: ${LEGAL_META.childSafetyContactName}`,
      `Email: ${LEGAL_META.childSafetyContactEmail}`,
      `General support: ${LEGAL_META.supportEmail}`,
      `Legal notices: ${LEGAL_META.contactEmail}`,
      `Last updated: ${LEGAL_META.lastUpdated}`,
    ],
  },
];
